// Разбивката на продаденото при разнасяне — от кои сервитьори и станции идва
// продаденото на отчета (BE `service_report_sales_breakdown.py`,
// `GET /inventory/report-postings/sales-breakdown?reportId=`). САМО информация
// до „Продадено": не влияе на складовете и на записа на разнасянето. Само бройки,
// без пари. Плоски редове + речници — изгледите (по рецепти, сервитьори,
// станции) се смятат във FE (`reportPostingSalesBreakdownModel.ts`). Имената на
// рецептите не идват оттук — те са в прегледа (`ReportPostingPreview.recipes`).
// Договорът е в BE docs/inventory.md §FE↔BE договор. Количествата са `number`
// като във всички складови отговори (BE ги сериализира като float).
import { api } from "./client";

// Сервитьор = собственикът на личния отчет в отчета на заведението (на него е
// масата, не кой е маркирал). Идва и без продажби (почистени сметки).
export interface ReportSalesWaiter {
  waiterId: number | null;
  name: string | null; // снимката на името от личния отчет
  billsCount: number; // сметките от личните му отчети
}

// Станцията на продадените редове (на добавката — нейната) и складът ѝ тук
export interface ReportSalesStation {
  stationId: number;
  name: string;
  warehouseId: number | null;
  warehouseName: string | null;
}

// Продадено к-во на продаваем (recipeId) от един сервитьор на една станция
export interface ReportSalesRow {
  sellableId: number;
  waiterId: number | null;
  stationId: number;
  quantity: number;
}

export interface ReportSalesBreakdown {
  reportId: number;
  waiters: ReportSalesWaiter[]; // по име
  stations: ReportSalesStation[]; // в реда на org екрана
  rows: ReportSalesRow[];
}

export async function getReportSalesBreakdown(reportId: number): Promise<ReportSalesBreakdown> {
  const res = await api.get<ReportSalesBreakdown>("/inventory/report-postings/sales-breakdown", {
    params: { reportId },
  });
  return res.data;
}
